import React from 'react';
import { motion } from 'framer-motion';
const collections = [{
  id: 4,
  title: 'Корсет + спідниця міді з шовку',
  subtitle: 'Лаконічний образ із жіночним характером',
  image: 'https://cdn.magicpatterns.com/uploads/3yhtC9q4Ur935EcgR2LC8E/photo_5303135715858259287_w.jpg'
}, {
  id: 5,
  title: 'Корсет + мініспідниця пліссе',
  subtitle: 'Лаконічний силует із акцентом на деталях',
  image: 'https://cdn.magicpatterns.com/uploads/uFdTHggTrdgP2ckSMbVpRp/IMG_3968.png'
}];
export function Collections() {
  return <section id="collections" className="py-24 bg-brand-cream" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-83">
            Вибрані колекції
          </h2>
          <p className="text-brand-dark/70 max-w-2xl mx-auto" data-id="element-84">
            Ретельно підібрані речі, створені, щоб доповнити ваш гардероб
            позачасовою вишуканістю.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-85">
          {collections.map((collection, index) => <motion.div key={collection.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group relative h-[500px] overflow-hidden rounded-2xl cursor-pointer" data-id="element-86">
              <img src={collection.image} alt={collection.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-87" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}